import React, {lazy, Suspense} from 'react'

const EducationLandingPageLazy = lazy(() =>
    import('./EducationLandingPage')
)

const EducationLandingPage = props => (
    <Suspense fallback={null}>
        <EducationLandingPageLazy {...props} />
    </Suspense>
)

export default EducationLandingPage
